import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcArrowmoreFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.116 8.116a1.25 1.25 0 1 1 1.768 1.768l-7 7a1.25 1.25 0 0 1-1.768 0l-7-7a1.25 1.25 0 1 1 1.768-1.768L12 14.232z"
  }));
}
var IcArrowmoreFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowmoreFill));

export { IcArrowmoreFill as I };
